export const RoutePaths = {
  Empty: "/",
  Transactions: "/transactions",
  Login: "/login",
  Game: "/game",
  Bets: "/bets",
  Jackpot: "/jackpot",
  Providers: "/providers",
  QRTicketDetails: "/ticketDetails",
  WildCard: "/*",
};
